import  { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Loader from "../../components/Loader/Loader";
import HeaderOne from "../../components/Header/HeaderOne";
import FooterOne from "../../components/Footer/FooterOne";
import { useParams } from "react-router-dom";

const ReportArchive = () => {
  const { id } = useParams(); // Extract the id from the URL
  const MARKET_ARCHIVE_URL = `${process.env.REACT_APP_IFRAME_BASE_URL}marketreport_archFRAME.php?id=${id}`;
  console.log("Market Archive URL:", MARKET_ARCHIVE_URL);
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <Loader>
      <HeaderOne  />
      <section className="white-bg">
      <div className="container my-5">
              <h2>Olshan Luxury Market Report - Archive</h2>
              </div>
       <br />
      <div style={{ position: 'relative', paddingBottom: '75.25%', height: 0 }}>
        
    <iframe
      src={`${MARKET_ARCHIVE_URL}`}
      title="OLSHAN LUXURY MARKET REPORT ARCHIVE"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        border: 0
      }}
      allowFullScreen
    />
  </div>

    
    </section>


      <FooterOne />
    </Loader>
  );
};



export default ReportArchive;